export default {
   styleOverrides: {
      root: {
         border: '1px solid #C8C8C8',
         borderRadius: 8,
         boxShadow: 'none'
      },
   }
};
